<app-dialog
  id="assign-lead-salesperson"
  [title]="'leadSalespersonDialog.assignLeadSalesperson' | translate"
  [confirmation]="'button.save' | translate"
  [isValid]="!formGroup.invalid"
  (save)="onSave()">
  <form id="assign-lead-salesperson-form" [formGroup]="formGroup">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-select
              [placeholder]="'input.selectOption' | translate"
              panelClass="mat-select-override"
              formControlName="salesperson"
              track="Clients, assign_lead_salesperson"
              [disabled]="isDataLoading"
            >
              <mat-option *ngFor="let option of salespeople; index as i" [value]="salespeople[i].uid">
                {{ option.first_name + " " + option.last_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</app-dialog>